<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
let banner = {url: '', jumpUrl: ''}

export default {
    data() {
        return {
            banners: []
        };
    },
    methods: {
        init() {
            this.getHomePageConfig()
        },
        async getHomePageConfig() {
            let data = await this.api.getHomePageConfig({
                access_token: localStorage.getItem("access_token"),
                type: 1
            })
            if(data) {
                let config = JSON.parse(data)
                if(config.length) {
                    this.banners = config.map(item => ({
                        url: item.banner,
                        jumpUrl: item.jump_url,
                    }))
                }else {
                    this.addBannerClick()
                }
            }
        },
        addBannerClick() {
            this.banners.push(JSON.parse(JSON.stringify(banner)))
        },
        async deleteBanner(idx) {
            await this.$confirm(`确认删除Banner_${idx + 1}？`)
            this.banners.splice(idx, 1)
        },
        moveDownClick(idx) {
            let item = this.banners.splice(idx, 1)
            this.banners.splice(idx + 1, 0, item[0])
        },
        moveUpClick(idx) {
            let item = this.banners.splice(idx, 1)
            this.banners.splice(idx - 1, 0, item[0])
        },
        async save() {
            let idx = this.banners.findIndex(item => !item.url.trim() || !item.jumpUrl.trim())
            if(~idx) {
                this.$message({ type: 'error', message: '请补全信息' })
                return
            }

            let config = this.banners.map(item => {
                let { url: banner, jumpUrl: jump_url } = item
                return { banner, jump_url }
            })

            let data = await this.api.setHomePageConfig({
                access_token: localStorage.getItem("access_token"),
                // 1 主页banner  2 信息表   3 玩转狮圈儿
                type: 1,
                config: JSON.stringify(config)
            })
            if(data) {
                console.log(data)
                this.$message({ type: 'success', message: '保存成功' })
            }
        }
    },
    created() {
        this.init();
    },
};
</script>
